import './hr.scss';

const Hr: React.FC = () => {
  return (
    <hr className="hr"/>
  )
}

export default Hr;
